<template>
  <!-- 需在父元素定位 -->
  <div class="scroll_menu">
    <div :class="{left_menu:true,isfixed:isFixed}">
      <div class="item" v-for="(v,i) in leftMenu" :key="i" @click="scrollInto(v.ref)">
        <img v-lazy="v.src" />
        <h5>{{v.name}}</h5>
      </div>
    </div>

    <div :class="{right_menu:true,isfixed:isFixed}">
      <div class="item" v-for="(v,i) in rightMenu" :key="i" @click="handClick(v.name)">
        <div class="img">
          <el-badge v-if="v.name==='购物车'" class="cart" :value="shoppingCartList.length" :max="99">
            <img v-lazy="v.src" />
          </el-badge>
          <img v-else v-lazy="v.src" />
        </div>
        <h5>{{v.name}}</h5>
        <div class="qrcode" v-if="v.assetsImg">
          <img :src="v.assetsImg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetShopCartList } from "@/pages/page1/api/modules/shoppingCart";
const leftMenu = [
  {
    name: "人气推荐",
    ref: "header",
    src: require("@/assets/img/leftMenu1.png"),
  },
  {
    name: "多比优选",
    ref: "duobi",
    src: require("@/assets/img/leftMenu2.png"),
  },
  {
    name: "热销套系",
    ref: "hotsale",
    src: require("@/assets/img/leftMenu3.png"),
  },
];
const rightMenu = [
  {
    name: "客服1",
    src: require("@/assets/img/rightMenu11.png"),
    assetsImg: require("@/assets/img/kefu1.png"),
  },
  {
    name: "客服2",
    src: require("@/assets/img/rightMenu11.png"),
    assetsImg: require("@/assets/img/kefu2.png"),
  },
  // {
  //   name: "体验馆",
  //   src: require("@/assets/img/rightMenu2.png"),
  //   assetsImg: "",
  // },
  {
    name: "购物车",
    src: require("@/assets/img/rightMenu3.png"),
    assetsImg: "",
  },
  {
    name: "小程序",
    src: require("@/assets/img/rightMenu4.png"),
    assetsImg: require("@/assets/img/qrCode2.png"),
  },
  {
    name: "公众号",
    src: require("@/assets/img/rightMenu5.png"),
    assetsImg: require("@/assets/img/qrCode3.jpg"),
  },
  {
    name: "返回顶部",
    src: require("@/assets/img/rightMenu6.png"),
    assetsImg: "",
  },
];
export default {
  props: {
    styleList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      leftMenu,
      rightMenu,
      isFixed: false,
      shoppingCartList: [],
    };
  },
  mounted() {
    this.styleList.forEach((v, i) => {
      this.leftMenu.push({
        name: v.title,
        ref: "style" + i,
        src: v.themeFileUrl,
      });
    });
    window.addEventListener("scroll", this.handleScroll);
    if (this.$cookies.isKey("ACCESS_TOKEN")) {
      this.getShoppingCart();
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      // 页面被卷去的上高度
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //   console.log(scrollTop);
      this.isFixed = scrollTop >= 763 ? true : false;
    },
    scrollInto(ref) {
      this.$emit("scrollInto", ref);
    },
    handClick(name) {
      if (name === "购物车") {
        this.goRequirePage("/shopCart");
      }
      if (name === "返回顶部") {
        window.scrollTo({
          left: 0,
          top: 0,
          // behavior: "smooth",
        });
      }
    },
    // 去需要登录的页面
    goRequirePage(path) {
      if (this.$cookies.isKey("ACCESS_TOKEN")) {
        let newUrl = this.$router.resolve(path);
        window.open(newUrl.href, "_blank");
      } else {
        this.goWithRedirect(path);
      }
    },
    // 去登录页 或者注册页带重定向地址
    goWithRedirect(path, register) {
      let newUrl = this.$router.resolve({
        path: register ? "/register" : "/login",
        query: {
          redirect: path,
        },
      });
      window.open(newUrl.href, "_self");
    },
    getShoppingCart() {
      GetShopCartList({}).then((res) => {
        let arr = [];
        // console.log("获取购物车列表", res);
        res.data.forEach((v) => {
          v.shoppingCartList.forEach((item) => {
            arr.push(item);
          });
        });
        this.shoppingCartList = arr;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@media (max-width: 1400px) {
  .left_menu {
    left: 0 !important;
  }
  .right_menu {
    right: 0 !important;
  }
}
.left_menu {
  position: absolute;
  left: calc((100% - 1190px) / 2 / 2);
  top: 869px;
  z-index: 30;
  background: #ffffff;
  .item {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;
    img {
      width: auto;
      height: auto;
      display: block;
      max-width: 100%;
    }
    h5 {
      display: none;
      width: 100%;
      height: 100%;
      line-height: 15px;
      padding: 10px;
      box-sizing: border-box;
      background: @themeColor;
      color: #ffffff;
      font-size: 14px;
      font-weight: 500;
    }
    &:hover {
      img {
        display: none;
      }
      h5 {
        display: block;
      }
      &::after {
        display: none;
      }
    }
    // 下个兄弟的横杠隐藏
    &:hover + .item {
      &::after {
        display: none;
      }
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -10px;

      width: 20px;
      height: 1px;
      background: #cfcfcf;
    }
    &:first-child {
      &::after {
        display: none;
      }
    }
  }
}
.right_menu {
  position: absolute;
  right: calc((100% - 1190px) / 2 / 2);
  top: 869px;
  z-index: 30;
  .item {
    width: 64px;
    height: 64px;
    background: #ffffff;
    box-shadow: 0px 2px 3px 0px rgba(4, 0, 0, 0.2);
    margin-bottom: 2px;
    cursor: pointer;
    position: relative;
    .img {
      width: 100%;
      text-align: center;

      position: absolute;
      bottom: 24px;
      left: 0;
      img {
        width: auto;
        height: auto;
      }
    }
    h5 {
      font-size: 12px;
      font-weight: 400;
      color: #535353;

      width: 100%;
      text-align: center;

      position: absolute;
      bottom: 6px;
      left: 0;
    }
    .qrcode {
      position: absolute;
      right: 100%;
      top: 0;
      margin-right: 16px;
      box-sizing: border-box;
      padding: 8px;
      background: #ffffff;
      border-radius: 6px;
      box-shadow: 0 0 5px 2px #ececec;
      display: none;
      img {
        width: 210px;
        height: 210px;
      }
      &::after {
        display: block;
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        left: 100%;
        top: 20px;
        border-width: 5px 5px;
        border-style: solid;
        border-color: transparent transparent transparent #ffffff;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }
    &:hover {
      h5 {
        color: @themeColor;
      }
      .qrcode {
        display: block;
      }
    }
  }
}
.isfixed {
  position: fixed;
  top: 50%;
  margin-top: -200px;
}
/deep/ .el-badge {
  .el-badge__content {
    min-width: 10px;
    height: 14px;
    line-height: 14px;
    padding: 0 2px;
    border: none;
  }
  .el-badge__content.is-fixed {
    top: 8px;
    right: 12px;
  }
}
</style>